import VueFormGenerator from 'vue-form-generator';
import helper from '@/components/new_deal/libs/helper';


export default {
  schema: {
    fields: [
      {
        type: 'currency',
        label: 'What is your estimated value of the property after repairs?',
        model: 'propertyRepair.afterRepairEstimate',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        required: true,
        styleClasses: 'col-md-12',
        validator: [VueFormGenerator.validators.string, 'customDollarValidator'],
        visible(model) {
          return helper.needsRepair(model);
        },
      },
      {
        type: 'currency',
        label: 'What is the total cost of repairs?',
        model: 'propertyRepair.totalCost',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        required: true,
        styleClasses: 'col-md-12',
        validator: [VueFormGenerator.validators.string, 'customDollarValidator'],
        visible(model) {
          return helper.needsRepair(model);
        },
      },
      {
        type: 'radios',
        label: 'Would you like us to fund your repairs into a holdback account?',
        model: 'propertyRepair.holdback',
        required: true,
        styleClasses: 'col-md-12 bool-radio',
        values: [
          { name: 'Yes', value: true },
          { name: 'No', value: false },
        ],
        validator: VueFormGenerator.validators.required,
        visible(model) {
          return helper.needsRepair(model);
        },
      },
      {
        type: 'currency',
        label: 'What is the total amount of repairs that have been completed to date?',
        model: 'propertyRepair.totalAmountCompleted',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        styleClasses: 'col-md-12',
        validator(value, field, model) {
          const validatorReturnValue = VueFormGenerator.validators.customDollarValidator(value);

          if (validatorReturnValue !== null && validatorReturnValue.length) {
            return validatorReturnValue;
          }
          return field.required(model) ?
            VueFormGenerator.validators.string(value, field, model) :
            null;
        },
        required(model) {
          return helper.notRefinanceBridge(model);
        },
        visible(model) {
          return helper.isRefinance(model);
        },
      },
      {
        type: 'currency',
        label: 'What is the amount of repairs left to be completed?',
        model: 'propertyRepair.totalAmountRemaining',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        styleClasses: 'col-md-12',
        validator(value, field, model) {
          const validatorReturnValue = VueFormGenerator.validators.customDollarValidator(value);
          if (validatorReturnValue !== null && validatorReturnValue.length) {
            return validatorReturnValue;
          }
          return field.required(model) ?
            VueFormGenerator.validators.string(value, field, model) :
            null;
        },
        required(model) {
          return helper.notRefinanceBridge(model);
        },
        visible(model) {
          return helper.isRefinance(model);
        },
      },
      {
        type: 'radios',
        label: 'Do you plan on adding additional SqFt?',
        model: 'propertyRepair.hasAdditionalSqFt',
        required: true,
        styleClasses: 'col-md-12 bool-radio',
        values: [
          { name: 'Yes', value: true },
          { name: 'No', value: false },
        ],
        validator: VueFormGenerator.validators.required,
        visible(model) {
          return helper.rehabOrOther(model);
        },
        onChanged(model) {
          /* eslint no-param-reassign: ["error", { "props": false }] */
          try {
            model.propertyRepair.additionalRooms = null;
            model.propertyRepair.additionalBathrooms = null;
            model.propertyRepair.additionalSqFt = null;
            model.propertyRepair.totalSqFtAfterRepairs = null;
            model.propertyRepair.permits = {
              exists: null,
              explanation: null,
            };
          } catch (_) { /* If model is not loaded, don't bother */ }
        },
      },
      {
        type: 'input',
        inputType: 'number',
        label: 'Additional Rooms',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        model: 'propertyRepair.additionalRooms',
        styleClasses: 'col-md-12',
        required: true,
        validator: VueFormGenerator.validators.integer,
        onChanged(model) {
          /* eslint no-param-reassign: ["error", { "props": false }] */
          try {
            model.propertyRepair.futureAdditionalRooms = model.propertyRepair.additionalRooms +
              model.property.address.bedrooms;
          } catch (_) { /* If model is not loaded, don't bother */ }
        },
        visible(model) {
          return helper.shouldDisplayAdditionalField(model);
        },
      },
      {
        type: 'input',
        inputType: 'number',
        label: 'Future Rooms',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        model: 'propertyRepair.futureAdditionalRooms',
        styleClasses: 'col-md-12',
        readonly: true,
        visible: false,
      },
      {
        type: 'input',
        inputType: 'number',
        label: 'Additional Bathrooms',
        model: 'propertyRepair.additionalBathrooms',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        styleClasses: 'col-md-12',
        required: true,
        validator: VueFormGenerator.validators.integer,
        onChanged(model) {
          /* eslint no-param-reassign: ["error", { "props": false }] */
          try {
            const totalBaths = model.property.address.total_baths_calculated;
            const additionalBaths = model.propertyRepair.additionalBathrooms;
            model.propertyRepair.futureAdditionalBathrooms = additionalBaths + totalBaths;
          } catch (_) { /* If model is not loaded, don't bother */ }
        },
        visible(model) {
          return helper.shouldDisplayAdditionalField(model);
        },
      },
      {
        type: 'input',
        inputType: 'number',
        label: 'Future Bathrooms',
        model: 'propertyRepair.futureAdditionalBathrooms',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        styleClasses: 'col-md-12',
        readonly: true,
        visible: false,
      },
      {
        type: 'input',
        inputType: 'number',
        label: 'Additional SqFt',
        model: 'propertyRepair.additionalSqFt',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        styleClasses: 'col-md-12',
        required: true,
        validator: VueFormGenerator.validators.double,
        visible(model) {
          return helper.shouldDisplayAdditionalField(model);
        },
        onChanged(model) {
          /* eslint no-param-reassign: ["error", { "props": false }] */
          try {
            const sqft = model.property.address.building_sqft;
            model.propertyRepair.totalSqFtAfterRepairs = model.propertyRepair.additionalSqFt + sqft;
          } catch (_) { /* If model is not loaded, don't bother */ }
        },
      },
      {
        type: 'input',
        inputType: 'number',
        label: 'Total SqFt After Repairs',
        model: 'propertyRepair.totalSqFtAfterRepairs',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        styleClasses: 'col-md-12',
        required: true,
        readonly: true,
        validator: VueFormGenerator.validators.double,
        visible(model) {
          return helper.shouldDisplayAdditionalField(model);
        },
      },
      {
        type: 'radios',
        label: 'Do you have permits?',
        model: 'propertyRepair.permits.exists',
        required: true,
        styleClasses: 'col-md-12 bool-radio',
        values: [
          { name: 'Yes', value: true },
          { name: 'No', value: false },
        ],
        validator: VueFormGenerator.validators.required,
        visible(model) {
          return helper.shouldDisplayAdditionalField(model);
        },
        onChanged(model) {
          /* eslint no-param-reassign: ["error", { "props": false }] */
          try {
            model.propertyRepair.permits.explanation = null;
          } catch (_) { /* If model is not loaded, don't bother */ }
        },
      },
      {
        type: 'textArea',
        model: 'propertyRepair.permits.explanation',
        placeholder: 'Explain.',
        rows: 3,
        required: true,
        styleClasses: 'col-md-12',
        validator: VueFormGenerator.validators.string,
        visible(model) {
          try {
            return model.propertyRepair.permits.exists === false;
          } catch (_) {
            return false;
          }
        },
      },
    ],
  },
  formOptions: {
    validationErrorClass: 'invalid-input',
    validateAfterChanged: true,
    fieldIdPrefix: 'repair-',
  },
};



// WEBPACK FOOTER //
// ./src/components/new_deal/components/repairs/schema.js